import { Component, Input } from '@angular/core';
import { Modal } from 'bootstrap';
import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';

@Component({
	selector: 'app-tourism-events-season',
	templateUrl: './tourism-events-season.component.html',
	styleUrls: ['./tourism-events-season.component.css'],
})
export class TourismEventsSeasonComponent {
	@Input() eventId: string = null;
	LoaderService = false;
	season: string = null;
	countCrewToSeason = null;
	data: Array<any> = [];
	count: Array<any> = [];
	kind: Array<any> = [
		{ idKind: 1, name: 'Wyjazd&Powrót' },
		{ idKind: 2, name: 'Wyjazd' },
		{ idKind: 3, name: 'Powrót' },
	];

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly question: QuestionService,
	) {}

	seasonOpen() {
		new Modal(document.getElementById('seasonEventDialog')).show();
		this.loadData();
	}
	private loadData() {
		this.api.get('/seasonTourismEvents/' + this.eventId + '/', (result, error) => {
			if (error) {
				return;
			}
			this.data = result.data;
		});
		const data = {
			cmd: 'tourismEvents',
			eventId: this.eventId,
		};
		this.api.command('/SeasonTourismEvents/', data, (result, error) => {
			if (error) {
				return;
			}
			this.count = result.data;
		});
	}

	linkSave() {
		this.LoaderService = true;
		this.api.post(
			'/seasonTourismEvents/',
			{ tourismEventsId: this.eventId, seasonId: this.season, kind: 1 },
			(result, error) => {
				this.LoaderService = false;
				if (error) {
					return;
				}
				this.season = '';
				this.loadData();
			},
		);
	}

	deleteAsk(data) {
		const question = this.question.ask('Czy jest pewien?', 'deleteConnection').subscribe((result) => {
			if (result.dialogId !== 'deleteConnection') {
				return;
			}
			question.unsubscribe();
			if (!result.result) {
				return;
			}
			this.api.del('/seasonTourismEvents/' + this.eventId + '/' + data.seasonId + '/', (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		});
	}

	linkClose() {
		const modal = Modal.getInstance(document.getElementById('seasonEventDialog'));
		if (!modal) {
			return;
		}
		modal.hide();
	}
	save(item) {
		const data = {
			cmd: 'update',
			id: item.id,
			kind: item.kind,
			seasonId: item.seasonId,
			countCrewToSeason: item.countCrewToSeason,
			eventId: this.eventId,
		};
		this.api.command('/seasonTourismEvents/', data, (result, error) => {
			if (error) {
				return;
			}
		});
	}

	crewSave() {
		const data = {
			cmd: 'countCrewToSeason',
			eventId: this.eventId,
			countCrewToSeason: this.count,
		};
		this.api.command('/TourismEvents/', data, (result, error) => {
			if (error) {
				return;
			}
			this.infobox.success('Zapisano');
		});
	}
}
